import styled from 'styled-components'

import { timingDefault } from '@syconium/little-miss-figgy'

export const Container = styled.div`
  align-items: center;
  display: flex;
`

export const ColumnAction = styled.button`
  align-items: center;
  border-inline-end: 1px solid ${o => o.theme.color.deprecated.gray.light};
  display: flex;
  justify-content: center;
  outline: none;
  padding: 4px 20px;
`

export const RightColumnAction = styled(ColumnAction)`
  border-inline-end: none;
  padding-inline-end: 0;
`

export const Rectangle = styled.div<{
  height: string
  isSelected: boolean
  width: string
}>`
  background: ${o => (o.isSelected ? 'black' : o.theme.color.deprecated.gray.light)};
  height: ${o => o.height};
  transition: background-color ${timingDefault} ease;
  width: ${o => o.width};
`

export const MultiColumnIconSvgGroup = styled.g<{ isSelected: boolean }>`
  fill: ${o => (o.isSelected ? 'black' : o.theme.color.deprecated.gray.light)};
  transition: fill ${timingDefault} ease;
`
